import { Category } from '@sb-tools/typescript/models/category.model';

export function getCategoryById(categories: Category[], categoryId: number) {
    const category = categories.find((cat) => {
        return cat.id === +categoryId;
    });

    if (category) {
        return category;
    } else {
        let categoriesChildren = [];
        categories.forEach((cat) => {
            categoriesChildren = categoriesChildren.concat(cat.children);
        });

        if (categoriesChildren.length > 0) {
            return getCategoryById(categoriesChildren, categoryId);
        } else {
            return null;
        }
    }
}
